import { MY_RAYMAND_URL } from '../constants'
import { useEffect } from 'react'

const NavigateSignin = () => {
  useEffect(() => {
    if (process.env.NODE_ENV !== 'development')
      window.location.replace(`${MY_RAYMAND_URL}/landing/login`)
  }, [])

  return null
}

export default NavigateSignin
